/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { LOADER_STATUS, SAVE_DATA, SET_IS_EDIT,SAVE_REJECTED_DATA,PROFILE_DATA,SAVE_SAVED_DATA, SAVE_TRACK_RETURN, SAVE_VALIDATION_DATA, SAVE_PREVIEW_FETCH_DATA, SAVE_PREVIEW_COMPARATIVE_DATA, SAVE_HISTORY_DATA,SET_ENTITY_LIST, SET_IS_SAVE_TO_GSTIN_MODAL, SAVE_GSTIN_MODAL_LIST_DATA, SET_TOTAL_PAGES} from './constants';

// The initial state of the App
export const initialState = {
  masterData: [],
  data: [],
  loaderStatus: false,
  totalRecord:'',
  entityList:[],
  rejectedData:[],
  gstinList:[],
  isEdit: false,
  profileData:[],
  savedData:[],
  previewFetchData:[],
  previewComparativeData:[],
  trackReturn:[],
  validatonData:[],
  historyData: [],
  entityMasterList:[],
  openSaveToGstinModal: false,
  SaveToGstinModalData: [],
  totalPages: 0,
  isGstnListActive:false
};


/* eslint-disable default-case, no-param-reassign */
const summaryDataReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case SET_IS_EDIT:
        return {
          ...state,
          isEdit: !state.isEdit
        }
      case SET_TOTAL_PAGES:
        return {
          ...state,
          totalPages: action.payload,
        }
      case SAVE_DATA:
        return {
          ...state,
          entityList: action.data.entityList,
          gstrList: action.data.gstinList,
        }
      case SAVE_PREVIEW_FETCH_DATA:
        console.log(action.data,"perview data in action")
        return {
          ...state,
          previewFetchData: action.data,
        }
      case SAVE_PREVIEW_COMPARATIVE_DATA:
        return {
          ...state,
          previewComparativeData: action.data,
        }
      case SAVE_HISTORY_DATA:
        return {
          ...state,
          historyData: action.data,
        }

        case SAVE_REJECTED_DATA:
          return {
            ...state,
            rejectedData: action.data,
          }

          case SAVE_SAVED_DATA:
            return {
              ...state,
              savedData: action.data,
            }

          case PROFILE_DATA:
            return {
              ...state,
              profileData:action.profileData
            }
            case SAVE_TRACK_RETURN:
              return {
                ...state,
                trackReturn:action.data
              }

              case SAVE_VALIDATION_DATA:
                console.log("validatonData:",action.data)
                return {
                  ...state,
                  validatonData:action.data
                }
              case SET_IS_SAVE_TO_GSTIN_MODAL:
                return {
                  ...state,
                  openSaveToGstinModal:!state.openSaveToGstinModal,
                }
              case SAVE_GSTIN_MODAL_LIST_DATA:
                return {
                  ...state,
                  SaveToGstinModalData:action.data,
                }
            
      case SET_ENTITY_LIST:
        return {
          ...state,
          entityMasterList:action.payload
        }
      default:
        return state; 
    }
  };

export default summaryDataReducer;
